"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _BasicInput = _interopRequireDefault(require("../BasicInput"));

var _awesomePhonenumber = _interopRequireDefault(require("awesome-phonenumber"));

var _config = _interopRequireDefault(require("./config"));

var _Checkmark = _interopRequireDefault(require("./Checkmark"));

var _Errormark = _interopRequireDefault(require("./Errormark"));

require("./PhoneInput.scss");

require("./checkmark.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function parseMSISDN(country, msisdnOriginal) {
  var msisdn = msisdnOriginal.indexOf("0") == 0 ? parseInt(msisdnOriginal, 10).toString() : msisdnOriginal;

  try {
    var parsedPhoneNumber = new _awesomePhonenumber.default(msisdn, country.toUpperCase());
    var nationalNumber = parsedPhoneNumber.getNumber('national') || "";
    var internationalNumber = parsedPhoneNumber.getNumber('international') || "";
    var bupperNumber = getBupperNumber(nationalNumber); //const isValid = isValidPhoneNumber(msisdn, country.toUpperCase());

    var internationalPrefix = parsedPhoneNumber.getCountryCode();
    var isValid = parsedPhoneNumber.isValid();

    if (country && country.toLowerCase() == "ci") {
      isValid = parsedPhoneNumber.isPossible() || parsedPhoneNumber.isMobile() || nationalNumber.length == 8 || nationalNumber.length == 9;
    }

    return {
      nationalNumber: nationalNumber,
      internationalNumber: internationalNumber,
      bupperNumber: bupperNumber,
      isValid: isValid,
      internationalPrefix: internationalPrefix
    };
  } catch (ex) {
    console.warn(ex);
    return {
      nationalNumber: "",
      internationalNumber: "",
      bupperNumber: "",
      isValid: false
    };
  }
}

function getBupperNumber(nationalNumber) {
  if (!nationalNumber || nationalNumber.length == 0) {
    return nationalNumber;
  } else {
    var match = nationalNumber.match(/\d+/gm);

    if (!match) {
      return nationalNumber;
    } else {
      return match.join("");
    }
  }
}

function hasNumber(myString) {
  return /\d/.test(myString);
}

var specialCountryCodes = {
  "s2": "sa",
  "o2": "om",
  "a2": "ae",
  "k2": "kw",
  "c2": "ch",
  "r2": "rs",
  "l2": "lv",
  "s3": "se",
  "b2": "bh",
  "g2": "gr",
  "a3": "at"
}; // cookie functions

function setCookie(name, value, daysToExpire) {
  var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
  var cookieString = "".concat(name, "=").concat(encodeURIComponent(value));

  if (daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
    cookieString += "; expires=".concat(date.toUTCString());
  }

  cookieString += "; path=".concat(path);
  document.cookie = cookieString;
}

function getCookie(name) {
  var cookieValue = document.cookie.match("(^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
  return cookieValue ? decodeURIComponent(cookieValue.pop()) : '';
}

var MsisdnComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MsisdnComponent, _React$Component);

  var _super = _createSuper(MsisdnComponent);

  function MsisdnComponent() {
    var _this;

    _classCallCheck(this, MsisdnComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isValid: false,
      showError: false
    });

    return _this;
  }

  _createClass(MsisdnComponent, [{
    key: "focusOnInputElement",
    value: function focusOnInputElement() {
      // add autofocus attribute on phone input by querySelector
      var phoneInputId = "#".concat(this.props.id ? this.props.id : "phone-input");
      var phoneInput = document.querySelector(phoneInputId);

      if (typeof window !== 'undefined' && phoneInput !== null && !phoneInput.attributes['autofocus']) {
        phoneInput.setAttribute('autofocus', '');
      } // focus on phone input by inputElementRef


      if (!!this.props.inputElementRef && !!this.props.inputElementRef.current) {
        var inputElement = this.props.inputElementRef.current;
        setTimeout(function () {
          if (inputElement != null) {
            inputElement.focus();
          }
        }, 123);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // focus on inputElementRef when the component mounts
      this.focusOnInputElement(); // get msisdn from cookies and localStorage

      var msisdnFromLocalStorage = localStorage.getItem('_uuid');
      var msisdnFromCookie = getCookie('_uuid'); // set the msisdn if available in any of the following

      var msisdnFromAnyStorage = msisdnFromLocalStorage || msisdnFromCookie || '';
      var decryptedMsisdn = window.atob(msisdnFromAnyStorage); // if msisdn is present, trigger onChange

      if (decryptedMsisdn && decryptedMsisdn !== '') {
        var country = hasNumber(this.props.countryCode) ? specialCountryCodes[this.props.countryCode] : this.props.countryCode;

        var _parseMSISDN = parseMSISDN(country, decryptedMsisdn),
            nationalNumber = _parseMSISDN.nationalNumber,
            internationalNumber = _parseMSISDN.internationalNumber,
            bupperNumber = _parseMSISDN.bupperNumber,
            isValid = _parseMSISDN.isValid;

        this.props.onChange({
          msisdn: decryptedMsisdn,
          isValid: isValid,
          nationalNumber: nationalNumber,
          internationalNumber: internationalNumber,
          bupperNumber: bupperNumber
        });
        this.setState({
          isValid: isValid
        }); //@ts-ignore

        window.msisdn = decryptedMsisdn;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.showError != prevProps.showError) {
        this.setState({
          showError: this.props.showError
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var country = hasNumber(this.props.countryCode) ? specialCountryCodes[this.props.countryCode] : this.props.countryCode;

      var _getConfig = (0, _config.default)(country),
          countryCode = _getConfig.countryCode,
          commonPrefix = _getConfig.commonPrefix,
          maxLength = _getConfig.maxLength;

      var focusOnInputElement = this.focusOnInputElement.bind(this);
      var showCountryCode = typeof this.props.showCountryCode == "boolean" ? this.props.showCountryCode : false;
      var showFlag = typeof this.props.showFlag == "boolean" ? this.props.showFlag : true;
      var showMobileIcon = typeof this.props.showMobileIcon == "boolean" ? this.props.showMobileIcon : true;
      var saveValidNumber = typeof this.props.saveValidNumber == "boolean" ? this.props.saveValidNumber : false;
      return /*#__PURE__*/React.createElement("div", {
        className: "phone-input"
      }, showMobileIcon ? /*#__PURE__*/React.createElement("div", {
        className: "phone",
        onMouseDown: focusOnInputElement,
        onTouchStart: focusOnInputElement
      }) : null, showFlag ? /*#__PURE__*/React.createElement("div", {
        className: "flag",
        onMouseDown: focusOnInputElement,
        onTouchStart: focusOnInputElement,
        style: {
          backgroundImage: "url('https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.1/flags/4x3/".concat(country, ".svg')")
        }
      }) : null, showCountryCode ? /*#__PURE__*/React.createElement("div", {
        className: "country-code",
        onMouseDown: focusOnInputElement
      }, "(", countryCode, ")") : null, /*#__PURE__*/React.createElement(_BasicInput.default, {
        id: "".concat(this.props.id ? this.props.id : "phone-input"),
        name: "".concat(this.props.name ? this.props.name : "phone-input-name"),
        smartcaret: typeof navigator == "undefined" ? "true" : /SamsungBrowser/ig.test(navigator.userAgent) ? "false" : "true" //@ts-ignore
        ,
        ref: this.props.inputElementRef,
        placeholder: this.props.placeholder || "Enter phone number",
        country: country.toUpperCase(),
        className: "text-input",
        value: this.props.msisdn,
        onChange: function onChange(msisdn) {
          _this2.setState({
            showError: false
          }); // Requested by Aadam and partner for testing Luxembourg 


          if (msisdn.includes("3522100000012340")) {
            _this2.props.onChange({
              msisdn: msisdn,
              isValid: true,
              nationalNumber: msisdn,
              internationalNumber: msisdn,
              bupperNumber: msisdn
            });

            _this2.setState({
              isValid: true
            });

            return;
          }

          var _parseMSISDN2 = parseMSISDN(country, msisdn),
              nationalNumber = _parseMSISDN2.nationalNumber,
              internationalNumber = _parseMSISDN2.internationalNumber,
              bupperNumber = _parseMSISDN2.bupperNumber,
              isValid = _parseMSISDN2.isValid,
              internationalPrefix = _parseMSISDN2.internationalPrefix;

          _this2.props.onChange({
            msisdn: msisdn,
            isValid: isValid,
            nationalNumber: nationalNumber,
            internationalNumber: internationalNumber,
            bupperNumber: bupperNumber
          });

          _this2.setState({
            isValid: isValid
          });

          if (typeof window !== "undefined") {
            // @ts-ignore
            window.msisdn = msisdn; // if saveValidNumber is true and isValid, encrypt msisdn and save it to cookie and localStorage

            if (saveValidNumber && isValid) {
              var encryptedMsisdn = window.btoa(msisdn);
              setCookie('_uuid', encryptedMsisdn, 30, '/');
              localStorage.setItem('_uuid', encryptedMsisdn);
            }
          }
        },
        onPaste: this.props.onPaste ? this.props.onPaste : function () {
          return void 0;
        },
        onBlur: this.props.onBlur ? this.props.onBlur : function () {
          return void 0;
        },
        onFocus: this.props.onFocus ? this.props.onFocus : function () {
          return void 0;
        },
        onKeyPress: this.props.onKeyPress ? this.props.onKeyPress : function () {
          return void 0;
        },
        maxLength: this.props.maxLength
      }), /*#__PURE__*/React.createElement("div", {
        className: "checkmark-container",
        "data-checkmark-container": "true"
      }, this.state.showError ? /*#__PURE__*/React.createElement(_Errormark.default, {
        onClickErrorCheckMark: this.props.onClickErrorCheckMark ? this.props.onClickErrorCheckMark : function () {
          return console.log("");
        }
      }) : this.state.isValid ? /*#__PURE__*/React.createElement(_Checkmark.default, {
        onClickCheckMark: this.props.onClickCheckMark ? this.props.onClickCheckMark : function () {
          return console.log("");
        }
      }) : ""));
    }
  }]);

  return MsisdnComponent;
}(React.Component);

exports.default = MsisdnComponent;